// extracted by mini-css-extract-plugin
export default {"row":"AddFriendItem_row__42m3W","profilePic":"AddFriendItem_profilePic__1iU60","info":"AddFriendItem_info__rPHqQ"};